import { render, staticRenderFns } from "./config019Page.vue?vue&type=template&id=0c9853c1&"
import script from "./config019Page.vue?vue&type=script&lang=js&"
export * from "./config019Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports